import NiceModal from "@ebay/nice-modal-react";
import { Box, Chip } from "@mui/material";
import { useCustomModel } from "components/context/CustomProvider";
import { LabelValueForTags } from "components/ui/atoms/LabelValue";
import { getCommons } from "./fieldConverterHelpers";
import ObjectChip from "../components/ObjectChip";

export const ObjectFieldView = ({ field, value, formattedValue }) => {
  const model = useCustomModel(field.subModel);

  if (model && model.viewField) {
    const Component = model.viewField;
    return (
      <Component field={field} value={value} formattedValue={formattedValue} />
    );
  }

  return (
    <LabelValueForTags
      label={field.label}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      Tags={[<ObjectChip modelName={field.subModel} obj={value} />]}
      isMissing={
        value === undefined || value === null || value.toString().trim() === ""
      }
    />
  );
};

export const ObjectCell = ({ value, colDef }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
    >
      {value && (
        <ObjectChip obj={value} modelName={colDef._meta.field.subModel} />
      )}
    </Box>
  );
};

export const objectFieldConverter = ({ field }) => {
  const model = useCustomModel(field.subModel);

  if (model && model.converter) {
    return model.converter({ field, model });
  }

  return {
    ...getCommons({ field }),
    type: "string",
    display: "flex",
    renderCell: ObjectCell,
    valueFormatter: (value) => {
      if (!value) return "";
      if (typeof value === "object") {
        return JSON.stringify(value, null, 2);
      }
      return value.toString();
    },
    disableClickEvent: true,
  };
};
